/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {ImageIntroPage} from "./ImageIntroPage";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";

export class KarenIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.6, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xWays: true,
        xWaysInfectious: true,
        xBet: true,
        volatility: Volatility.INSANE
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public gameClientConfigurationApplied(): void {
        if (!SlotGame.apiPlugin.gameClientConfiguration.boostedBetExtraRows) {
            this.stampConfig.xBet = false;
            this.pages[0] = new ImageIntroPage([
                {
                    texture: ImgLoader.getImgTexture("feature1Boost"),
                    scale: 1,
                    position: new PIXI.Point(0, 0)
                }
            ]);
        }
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDivTop", "resources/images/Intro_Divider_Top.png");
        imgLoader.add("introDivBottom", "resources/images/Intro_Divider_Bottom.png");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature1Boost", "resources/images/intro_feature1_noenhanced.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature3", "resources/images/intro_feature3.png");
        imgLoader.add("logo", "resources/images/introLogo.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    public onClose(): void {
        KarenSoundManager.playSoundEffect(KarenSoundConfig.MAINGAME_MUSIC_START);
        KarenSoundManager.playSoundEffect(KarenSoundConfig.NEWSPAPER_INTRO);
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDivTop"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);
        //
        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDivBottom"));
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        logoSprite.position.y = 15;
        this.logo.addChild(logoSprite);

        this.pages = [
            new ImageIntroPage([
                {
                    texture: ImgLoader.getImgTexture("feature1"),
                    scale: 1,
                    position: new PIXI.Point(0, 0)
                }
            ]),
            new ImageIntroPage([
                {
                    texture: ImgLoader.getImgTexture("feature2"),
                    scale: 1,
                    position: new PIXI.Point(0, 0)
                }
            ]),
            new ImageIntroPage([
                {
                    texture: ImgLoader.getImgTexture("feature3"),
                    scale: 1,
                    position: new PIXI.Point(0, 0)
                }
            ]),
        ];
    }
}
